<template>
	<div>
		<a-form class="mb-4" :form="form" @submit="handleSubmit">
			<div class="row">
				<div class="col-md-6">
					<a-form-item class="m0" :label="product.is_service === 'true' ? 'Nombre del servicio' : 'Nombre del producto'">
						<a-input v-model="product.label" class="text-uppercase" />
					</a-form-item>
				</div>
				<div class="col-md-3">
					<a-form-item class="m0" label="SKU">
						<a-input type="number" v-model="product.sku" disabled />
					</a-form-item>
				</div>
				<div class="col-md-3">
					<a-form-item class="m0" label="Tipo">
						<a-radio-group v-model="product.is_service" button-style="solid" class="w-100 d-flex">
							<a-radio-button value="false" class="flex-fill text-center">Producto</a-radio-button>
							<a-radio-button value="true" class="flex-fill text-center">Servicio</a-radio-button>
						</a-radio-group>
					</a-form-item>
				</div>
				<div class="col-md-3">
					<a-form-item class="m0" label="Precio Público">
						<a-input prefix="$" v-money="money" v-model="product.prices.public_price" />
					</a-form-item>
				</div>
				<div class="col-md-3">
					<a-form-item class="m0" label="Precio Bronce">
						<a-input prefix="$" v-money="money" v-model="product.prices.price_bronze" />
					</a-form-item>
				</div>
				<div class="col-md-3">
					<a-form-item class="m0" label="Precio Plata">
						<a-input prefix="$" v-money="money" v-model="product.prices.price_silver" />
					</a-form-item>
				</div>
				<div class="col-md-3">
					<a-form-item class="m0" label="Precio Oro">
						<a-input prefix="$" v-money="money" v-model="product.prices.price_gold" />
					</a-form-item>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<hr class="hrText" />
				</div>
				<div class="col-md-4 text-left">
					<a-button class="ml5 btn btn-warning" icon="arrow-left" @click="onCancel">Regresar</a-button>
				</div>
				<div class="col-md-8 text-right">
					<a-button icon="save" class="btn btn-success" htmlType="submit">Guardar</a-button>
				</div>
			</div>
		</a-form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import { productModel } from '@/constants'
import _ from 'lodash'
import { VMoney } from 'v-money'
import utilities from '@/services/utilities'
import numeral from 'numeral'
import moment from 'moment'

export default {
	name: 'product_generalComponent',
	directives: {
		money: VMoney,
	},
	computed: {
		...mapGetters('products', ['actualProduct']),
	},
	data: function () {
		return {
			form: this.$form.createForm(this),
			money: {
				decimal: '.',
				thousands: ',',
				precision: 0,
			},
			product: _.cloneDeep(productModel.general),
		}
	},
	async beforeMount() {
		const productId = utilities.objectValidate(this.$route, 'params.id', false)
		if (productId) {
			if (!utilities.objectValidate(this.actualProduct, 'sku', false) || this.actualProduct.id != productId) {
				await this.$store.dispatch('products/GET_ONE_SILENT', { id: productId })
			}
			this.setLocalData()
		} else {
			this.product.sku = moment().valueOf()
		}
	},
	methods: {
		setLocalData() {
			this.product = _.cloneDeep({
				...productModel.general,
				label: this.actualProduct.label,
				sku: this.actualProduct.sku,
				is_service: this.actualProduct.is_service !== undefined ? String(this.actualProduct.is_service) : 'false',
			})

			this.product.prices.public_price = numeral(utilities.objectValidate(this.actualProduct, 'public_price', 0)).format('0,0')
			this.product.prices.price_bronze = numeral(utilities.objectValidate(this.actualProduct, 'price_bronze', 0)).format('0,0')
			this.product.prices.price_silver = numeral(utilities.objectValidate(this.actualProduct, 'price_silver', 0)).format('0,0')
			this.product.prices.price_gold = numeral(utilities.objectValidate(this.actualProduct, 'price_gold', 0)).format('0,0')
		},
		onCancel() {
			this.$router.replace('/almacen')
		},
		handleSubmit(e) {
			e.preventDefault()
			let errors = []

			if (!utilities.objectValidate(this.product, 'sku', false)) {
				errors.push('- Ingresa código de barras o SKU del producto')
			}
			if (!utilities.objectValidate(this.product, 'label', false)) {
				errors.push(this.product.is_service === 'true' ? '- Ingresa nombre del servicio' : '- Ingresa nombre del producto')
			}
			if (!utilities.objectValidate(this.product, 'prices.public_price', false)) {
				errors.push('- Ingresa el precio de venta público')
			}
			if (!utilities.objectValidate(this.product, 'prices.price_bronze', false)) {
				errors.push('- Ingresa el precio bronce')
			}
			if (!utilities.objectValidate(this.product, 'prices.price_silver', false)) {
				errors.push('- Ingresa el precio plata')
			}
			if (!utilities.objectValidate(this.product, 'prices.price_gold', false)) {
				errors.push('- Ingresa el precio oro')
			}

			if (errors.length) {
				Swal.fire({
					title: 'Atención',
					html: errors.join('<br>'),
					icon: 'warning',
					showCancelButton: false,
					confirmButtonText: 'Ok',
				})
				return false
			}

			if (utilities.objectValidate(this.$route, 'params.id', false)) {
				this.product.id = Number(this.$route.params.id)
				this.$store.dispatch('products/UPDATE', this.product).then((response) => {
					this.setLocalData()
				})
			} else {
				this.$store.dispatch('products/CREATE', this.product).then((response) => {
					if (response && response.id) {
						this.$router.replace(`/warehouse/products/${response.id}`)
					}
				})
			}
		},
	},
}
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>